// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3klr1","vLegacy":"SelectSecondary_vLegacy__16NiY","error":"SelectSecondary_error__2fi9B","disabled":"SelectSecondary_disabled__15f7r"};